import React from "react";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import AddUsers from "../AddUsers";

const AddUsersDialog = ({ open, onClose, refresh, isAdmin }) => {
  const handleRefresh = () => {
    if (refresh) refresh();
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { backgroundImage: "none" } }}
    >
      <Box
        sx={{
          "& .add-media-card": {
            boxShadow: "none !important",
            border: "none !important",
            background: "transparent !important",
          },
        }}
      >
        <AddUsers refresh={handleRefresh} isAdmin={isAdmin} />
      </Box>
    </Dialog>
  );
};

export default AddUsersDialog;
